import React from "react";

const Footer = () => {
    return (
        <div id="footer">
            <div>POEMS.PHOTOS.FICTION.ART.LAW.LOCAL NEWS.</div>
        </div>
    )
}

export default Footer;
